import { render, staticRenderFns } from "./AgeSlider.vue?vue&type=template&id=4bdf023c&scoped=true&"
import script from "./AgeSlider.vue?vue&type=script&lang=ts&"
export * from "./AgeSlider.vue?vue&type=script&lang=ts&"
import style0 from "./AgeSlider.vue?vue&type=style&index=0&id=4bdf023c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdf023c",
  null
  
)

export default component.exports